module.exports = __webpack_public_path__ + "static/media/instagrambanner.027e1e0f.png";